module.exports = __webpack_public_path__ + "static/media/game-bosstalking.5dfb3644.png";